import Box from "@mui/material/Box";
// Note(Pratik) Safe to use but interface may change once built into core MUI.
// Should verify this functionality upon migrating to MUI v6
import Grid from "@mui/material/Unstable_Grid2";
import * as React from "react";

import { DeletableBox } from "../DeletableBox";

import { JsonMetadataEditor } from "./JsonMetadataEditor";
import { Metadata } from "./types";
import { Value } from "./Value";

interface Props {
  metadata: Metadata;
  onChange?: (
    metadata: Metadata,
    diff?: {
      keysUpdated?: string[];
      keysDeleted?: string[];
    },
  ) => void;
  onDeleteMetadata?: (key: string) => void;
  disabled?: boolean;
  jsonMetadataDisabled?: boolean;
}

export const MetadataView: React.FC<Props> = ({
  metadata,
  onChange,
  onDeleteMetadata,
  disabled = false,
  jsonMetadataDisabled = false,
}) => {
  function removeKeyFromMetadata(key: string) {
    const copy = { ...metadata };
    delete copy[key];

    if (onChange) {
      onChange(copy, { keysDeleted: [key] });
    }

    if (onDeleteMetadata) {
      onDeleteMetadata(key);
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        margin: Object.keys(metadata).length > 0 ? "0.5rem 0 0.75rem" : 0,
      }}
      component="dl"
    >
      <Grid container spacing={1.5} alignContent={"top"}>
        {Object.keys(metadata)
          .sort((a, b) => {
            return a.localeCompare(b);
          })
          .map((mKey) => {
            const onDelete = () => {
              if (!disabled) {
                removeKeyFromMetadata(mKey);
              }
            };

            const value = metadata[mKey];

            let content = (
              <>
                <dt
                  style={{
                    fontSize: "0.8rem",
                  }}
                >
                  {mKey}
                </dt>
                <dd
                  style={{
                    lineHeight: 1.0,
                  }}
                >
                  <Value value={value} />
                </dd>
              </>
            );
            // Pardon the double-negatives, but it makes
            // for better parameter names on the outside.
            const enableEditing = !jsonMetadataDisabled && !disabled;
            if (enableEditing) {
              // Allow editing a non-disabled box.
              content = (
                <JsonMetadataEditor
                  value={value}
                  onObjectValueChanged={(newValue) => {
                    if (onChange) {
                      onChange(
                        { ...metadata, [mKey]: newValue },
                        { keysUpdated: [mKey] },
                      );
                    }
                  }}
                >
                  {content}
                </JsonMetadataEditor>
              );
            }
            return (
              <Grid key={mKey}>
                <DeletableBox onDelete={onDelete} disabled={disabled}>
                  {content}
                </DeletableBox>
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
};
